import { Component, OnInit } from '@angular/core';

import { DataService } from '@data/data.service';

@Component({
  selector: 'app-modal-loading-indicator',
  templateUrl: './modal-loading-indicator.component.html',
  styleUrls: ['./modal-loading-indicator.component.scss'],
})
export class ModalLoadingIndicatorComponent implements OnInit {
  constructor(public dataService: DataService) {}

  ngOnInit() {}
}
